import { HttpApiSchema } from "@effect/platform";
import { Predicate, Schema } from "effect";

export const EMAIL_ALREADY_CONNECTED_TO_ANOTHER_TEAM_MESSAGE =
  "This email is already connected to a different team. To connect it to this team, remove it from the other team first.";

export class EmailAlreadyConnectedToAnotherTeamError extends Schema.TaggedError<EmailAlreadyConnectedToAnotherTeamError>()(
  "EmailAlreadyConnectedToAnotherTeamError",
  { email: Schema.String },
  HttpApiSchema.annotations({ status: 409 }),
) {}

export const isEmailAlreadyConnectedToAnotherTeamError = (
  error: unknown,
): error is EmailAlreadyConnectedToAnotherTeamError =>
  Predicate.hasProperty(error, "_tag") &&
  error._tag === "EmailAlreadyConnectedToAnotherTeamError";
